export default class Device {
	static breakpoints = {
		mobile: 768,
		tablet: 1024,
		laptop: 1100,
	};

	static isDesktop = () => window.innerWidth > Device.breakpoints.laptop;
	static isLaptop = () =>
		window.innerWidth >= Device.breakpoints.tablet && window.innerWidth <= Device.breakpoints.laptop;
	static isTablet = () =>
		window.innerWidth >= Device.breakpoints.mobile && window.innerWidth <= Device.breakpoints.tablet;
	static isMobile = () => window.innerWidth < Device.breakpoints.mobile;
	static isTouchDevice = () => window.DocumentTouch && document instanceof DocumentTouch;
	static isBelowSize = (size) => window.innerWidth < size;
	static isAboveSize = (size) => window.innerWidth >= size;
}
